import { MdlModule } from '@angular-mdl/core';
import { NgModule } from '@angular/core';
import { CommonModule }  from '@angular/common';
import { HttpModule } from '@angular/http';

import { TranslateModule } from '../../../translate/translate.module';
import { MdlSelectModule } from '@angular-mdl/select';

import { DeleteComponent } from './delete.component';
import { FormsModule } from '@angular/forms';


@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    HttpModule,
    TranslateModule,
    MdlSelectModule,
    MdlModule
  ],
  declarations: [
    DeleteComponent
  ],
  exports: [DeleteComponent]
})
export class DeleteComponentModule { }